/*
 * 作者: Fultom
 * 创建时间: 2023-10-27 15:06:04
 * 最近修改时间: 2024-12-12 17:55:54
 * 功能:
 */
import { ajaxFunc } from '../tools';
const dataPerformance = {
    /****换货活动****/
    //换货规则
    postOcrInvoice: ajaxFunc('/salaryData/invoiceOcr', 'post'),
    
}

export default dataPerformance;



// WEBPACK FOOTER //
// ./src/request/api/dataPerformance.js